"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Edit;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function Edit(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M14.314 5.955l3.728 3.739a.377.377 0 0 1 0 .532l-8.236 8.236a.377.377 0 0 1-.533 0L5.54 14.73a.377.377 0 0 1 0-.533l8.24-8.242a.377.377 0 0 1 .267-.111.377.377 0 0 1 .267.112zM4.78 15.622l3.596 3.603a.377.377 0 0 1-.179.634L3.465 20.99a.383.383 0 0 1-.354-.1.377.377 0 0 1-.1-.354l1.136-4.735a.377.377 0 0 1 .264-.275.377.377 0 0 1 .37.096zM20.45 5.154a1.886 1.886 0 0 1 0 2.663l-1.069 1.07a.377.377 0 0 1-.533 0l-3.734-3.734a.377.377 0 0 1 0-.533l1.07-1.069a1.886 1.886 0 0 1 2.664 0l1.602 1.602z"
  }));
}